// Multilingual content for the link-redemption confirmation/denial landing page.
//
// NOTE FOR THE TEAM: these are TEMPLATE copies — the Spanish (es) strings are the
// ones provided so far; en/ca are first drafts to be reviewed/polished.
//
// The landing page renders one of the three states below based on the `status`
// query param the API redirect appends:
//   ?status=redeemed | already_redeemed | error
// Language is picked by getLocalizedContent (?lang=es|en|ca or browser language).

export const linkRedeemedContent = {
  // Happy path — first valid click, request stored.
  redeemed: {
    variant: 'success',
    title: {
      es: 'Hemos recibido tu petición',
      en: 'We have received your request',
      ca: 'Hem rebut la teva petició',
    },
    description: {
      es: 'Recibirás el reembolso de tu entrada en un plazo máximo de 7 días.',
      en: 'You will receive your ticket refund within 7 days.',
      ca: 'Rebràs el reemborsament de la teva entrada en un termini màxim de 7 dies.',
    },
  },

  // Bad path — code was already redeemed before.
  already_redeemed: {
    variant: 'info',
    title: {
      es: 'Ya hemos recibido tu petición anteriormente',
      en: 'We have already received your request previously',
      ca: 'Ja hem rebut la teva petició anteriorment',
    },
    description: {
      es: 'Recibirás el reembolso de tu entrada en un plazo máximo de 7 días a partir de tu petición.',
      en: 'You will receive your ticket refund within 7 days since your request.',
      ca: 'Rebràs el reemborsament de la teva entrada en un termini màxim de 7 dies a partir de la teva petició.',
    },
  },

  // Bad path — invalid/expired code or unexpected failure.
  error: {
    variant: 'error',
    title: {
      es: 'Oops, algo ha ocurrido',
      en: 'Oops, something went wrong',
      ca: 'Ups, alguna cosa ha fallat',
    },
    description: {
      es: 'Vuelve a intentarlo.',
      en: 'Please try again.',
      ca: 'Torna-ho a provar.',
    },
  },
}

export default linkRedeemedContent
